import React from 'react'
import { useNavigate  } from "react-router-dom";

function PageNotFount() {
  const navigate = useNavigate()

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex flex-col flex-grow justify-center items-center gap-2 bg-cover bg-no-repeat w-full"
      style={{ backgroundImage: "url('/error_page_bg.png')" }}>
      <img className="max-h-[108px] max-w-[108px]" src="/404_error_icon.png" alt="error icon" />
      <p className="text-2xl font-primary font-bold">Oops, Something went wrong.</p>
      <p className="text-base font-primary text-center max-w-[400px]">
        The page you're trying to visit could not be found. We recommend you to refresh this page or return to the home page.
      </p>
      <div className="flex flex-row gap-2">
        <button className="flex-1 min-w-[150px] px-6 py-4 rounded-[10px] bg-white font-primary font-semibold" onClick={handleRefresh}>
          Refresh
        </button>
        <button className="flex-1 min-w-[150px] px-6 py-4 rounded-[10px] bg-[#35B8D7] text-white font-primary font-semibold" onClick={()=>navigate("/dashboard")}>
          Back to Home
        </button>
      </div>
    </div>
  )
}

export default PageNotFount